import { Component, OnInit, OnDestroy, Input } from '@angular/core';
// ionic
import { ModalController } from '@ionic/angular';
import { Events } from '../../helpers/events';

// other libraries
import { TranslateService } from "@ngx-translate/core";

// rxjs
import { Subject, Subscription } from "rxjs";
import { debounceTime, takeUntil } from "rxjs/operators";

// services
import { EventService } from "../../services/event.service";
import { PlatformService } from "../../services/platform.service";
import { UserService } from "../../services/user.service";

// models
import { Event } from "../../models/event";
import { Keyword } from "../../models/keyword";
import { User } from "../../models/user";

@Component({
    selector: 'keyword-select',
    templateUrl: './keyword-select.component.html',
    styleUrls: ['./keyword-select.component.scss'],
})
export class KeywordSelectComponent implements OnInit, OnDestroy {

    /**
     * unsubscribe subject
     *
     * @type {Subject<void>}
     */
    private ngUnsubscribe: Subject<void> = new Subject<void>();

    /**
     * subscription for event changes subject
     *
     * @type {Subscription}
     */
    private subscriptionEvent: Subscription;

    /**
     * event
     *
     * @type {Event}
     */
    public event: Event;

    /**
     * user
     *
     * @type {User}
     */
    public user: User = new User;

    /**
     * selected language
     *
     * @type string
     */
    public userLang: string;

    @Input() pivots: any[] = [];

    /**
     * show loading
     *
     * @type {boolean}
     */
    public loading: boolean = true;

    constructor(
        public plt: PlatformService,
        public appEvents: Events,
        public eventService: EventService,
        public userService: UserService,
        public modalController: ModalController,
        public translate: TranslateService,
    ) {

        // user language
        this.userLang = this.translate.currentLang;
    }

    ngOnInit() {
        this.userService.getCurrentUser().pipe(
            takeUntil(this.ngUnsubscribe),
            debounceTime(0)
        ).subscribe(
            (user) => {
                if (user.id) {
                    this.user = user;

                    // cancel previous subscription
                    if (this.subscriptionEvent) {
                        this.subscriptionEvent.unsubscribe();
                    }

                    this.subscriptionEvent = this.eventService.getCurrentEvent().pipe(
                        takeUntil(this.ngUnsubscribe),
                        debounceTime(0)
                    ).subscribe((event) => {

                        this.event = event;
                        this.loading = false;
                    });
                } else {
                    // cancel previous subscription
                    if (this.subscriptionEvent) {
                        this.subscriptionEvent.unsubscribe();
                    }
                }
            });

    }

    /**
     * toggle keyword selection
     *
     * @param column
     * @param keyword
     * @returns {boolean}
     */
    public toggleKeyword(column: number, keyword: Keyword) {
        if (this.pivots && this.pivots.filter((item) => { return item.keyword_id == keyword.id && item.column == column }).length) {
            this.pivots = this.pivots.filter((item) => {
                return item.keyword_id != keyword.id || item.column != column;
            });
        } else {
            this.pivots.push({
                keyword_id: keyword.id,
                column: column,
                keyword: keyword,
            });
        }
    }

    /**
     * Check, if the keyword is selected
     *
     * @param column
     * @param keyword
     * @returns {boolean}
     */
    public isSelected(column: number, keyword: Keyword) {
        if (this.pivots && this.pivots.filter((item) => { return item.keyword_id == keyword.id && item.column == column }).length) {
            return true;
        }

        return false;
    }

    /**
     * close modal window
     *
     */
    public backClicked() {
        this.modalController.dismiss({
            action: 'close'
        });
    }

    public seeResults() {
        this.modalController.dismiss({
            action: 'close',
            keywords: this.pivots
        });
    }

    /**
     * on destroy
     *
     * @return void
     */
    ngOnDestroy() {
        this.ngUnsubscribe.next();
        this.ngUnsubscribe.complete();
    }
}
